var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C8.5 7.45 8.05 7 7.5 7C6.95 7 6.5 7.45 6.5 8C6.5 8.55 6.95 9 7.5 9C8.05 9 8.5 8.55 8.5 8Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8C11.15 13.8 12.05 13.25 12.9 12.1L12.1 11.5C11.4 12.4 10.8 12.8 10 12.8C9.2 12.8 8.6 12.4 7.9 11.5L7.1 12.1C7.95 13.25 8.85 13.8 10 13.8Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C13.05 7 13.5 7.45 13.5 8C13.5 8.55 13.05 9 12.5 9C11.95 9 11.5 8.55 11.5 8C11.5 7.45 11.95 7 12.5 7Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10ZM10 17C13.85 17 17 13.85 17 10C17 6.15 13.85 3 10 3C6.15 3 3 6.15 3 10C3 13.85 6.15 17 10 17Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmile);
export default __webpack_public_path__ + "static/media/icon-smile.1e33c6710658c6d2d7d5516d7650ca3e.svg";
export { ForwardRef as ReactComponent };